<template>
    <el-card class="box-card bread">
        <div>
            <img :src="point" alt="南软科技" class="bread_pin">
            <el-breadcrumb separator-class = "el-icon-d-arrow-right">
                <el-breadcrumb-item v-for="(item,index) in getBread" :key="index">{{item.meta.title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </el-card>
</template>

<script>
export default {
  name: "breadcrumb-wly",
  data() {
    return {
      point: require("./../../static/dingwei.png")
    };
  },
  computed: {
    getBread() {
      return this.$route.matched;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/BreadcrumbWly.vue